export const termsAndConditionsRelishLink =
  'https://www.grilld.com.au/legal-information/terms-conditions/relish-membership-program-terms'
export const profileCompletionTermsAndConditionsLink =
  'https://grilld.com.au/legal-information/relish-profile-completion-terms-conditions'
export const relishMembershipBenefitsPromotionsTermLink =
  'https://grilld.com.au/legal-information/terms-conditions/relish-benefits'
export const termsAndConditionsBurgerPassLink = 'https://grilld.com.au/burger-pass#terms'

export const termsAndConditionsLink = 'https://www.grilld.com.au/legal-information/terms-conditions'
export const privacyPolicyLink = 'https://www.grilld.com.au/legal-information/privacy-policy'

export const faqLink = 'https://grilld.zendesk.com/hc/en-au'
export const feedbackLink = 'https://www.grilld.com.au/feedback'

export const madBundayTermsAndConditionsLink = 'https://www.grilld.com.au/legal-information/terms-conditions/mad-bunday'
export const madBundayTermsAndConditionsCompetitionLink =
  'https://www.grilld.com.au/legal-information/terms-conditions/mad-bunday-competition'

export const allergensLink =
  'https://assets.ctfassets.net/quhz534suzyl/53CQABz8eEZ7Y1wMRy0AWY/4f5b68b40edfc6ea4e5ab3df8b43a7c9/Grilld_allergensheet_Nov23.pdf'
